import React, { useCallback, useRef, useState } from 'react';
import { Layout, Typography } from 'fronton-react';
import cn from 'clsx';
import { ButtonWithGAClickButton, Section } from 'common/components';
import { useIsomorphicLayoutEffect } from 'common/hooks';
import { lowerBoundsBreakpoints } from 'common/styles/breakpoints';
import { fullWidthButton } from 'common/components/button/button-styles';
import {
  signupBlock,
  bgImage,
  layout,
  signupBlockBody,
  signupBlockTitle,
  fullWidthLayout,
  fullWidthBgImage,
  imageWrapper,
  signupBlockHide,
  signupBlockBodyWrapper,
} from './animated-signup-block-styles';

type TProps = {
  elementBlock: string;
  signUpHref: string;
  refCb?: (el: HTMLElement | null) => void;
}

export const AnimatedSignupBlock: React.FC<TProps> = ({ elementBlock, signUpHref, refCb }) => {
  const [isFull, setIsFull] = useState(true);
  const bgRef = useRef<HTMLDivElement | null>(null);

  const handleScroll = useCallback(() => {
    if (bgRef?.current) {
      const { top } = bgRef.current.getBoundingClientRect();

      if ((top < 180 && top > -180)) {
        setIsFull(false);
      } else {
        setIsFull(true);
      }
    }
  }, [bgRef]);

  useIsomorphicLayoutEffect(() => {
    window.addEventListener('scroll', handleScroll);

    return () => {
      window.removeEventListener('scroll', handleScroll);
    }
  }, []);

  return (
    <Layout ref={refCb} className={cn(layout, { [fullWidthLayout]: isFull })}>
      <Section>
        <div
          className={imageWrapper}
          ref={(el: HTMLDivElement | null) => {
            bgRef.current = el;
          }}
        >
          <picture>
            <source
              srcSet={"https://cdn.lemanapro.ru/lmru/image/upload/v1782911776/fudzi/elbrus/images/landings/new-kitchen/animated-signup/bg-ld.jpg/bg-ld.jpg"}
              media={lowerBoundsBreakpoints['--from-tablet']}
            />
            <img
              className={cn({
                [bgImage]: !isFull,
                [fullWidthBgImage]: isFull,
              })}
              src="https://cdn.lemanapro.ru/lmru/image/upload/v1782911776/fudzi/elbrus/images/landings/new-kitchen/animated-signup/bg-m.jpg/bg-m.jpg"
              alt="Изображение кухни"
            />
          </picture>
          <div
            className={cn(
              signupBlock,
              {
                [signupBlockHide]: isFull
              }
            )}
          >
            <div className={signupBlockBody}>
              <div className={signupBlockBodyWrapper}>
                <Typography className={signupBlockTitle} variant="h2">
                  Сделайте кухню любимым местом
                </Typography>
                <Typography variant="l" size="body_long">
                  Не откладывайте свой комфорт. Запишитесь на бесплатный дизайн-проект — поможем со&nbsp;всеми этапами
                </Typography>
              </div>
              <ButtonWithGAClickButton
                className={fullWidthButton}
                elementBlock={elementBlock}
                elementName="Сделайте кухню любимым местом"
                elementText="Записаться"
                href={signUpHref}
                title="Записаться на консультацию"
                fullWidth
                variant="accent"
              >
                Записаться
              </ButtonWithGAClickButton>
            </div>
          </div>
        </div>
      </Section>
    </Layout>
  );
}
